import { EActiveView } from '../../types/view';
import { formatPhone } from '../../utils/formatString';
export function formattedPhoneSelector(state) {
  return state.view.active === EActiveView.PhoneAuthValidateCall || state.view.active === EActiveView.ConfirmPhone ? formatPhone(state.phoneAuth.phone) : '';
}